<template>
  <div>
    <el-dialog
      :visible.sync="open"
      title="Tips"
      :show-close="false"
      custom-class="filter-dialog"
    >
      <template v-slot:title>
        <div class="filter-title-box">
          <el-row >
            <el-col :xs="20"
                    :sm="20"
                    :md="20"
                    :lg="20"
                    :xl="20">
              <h3 class="filter-title">{{ title }}</h3>
            </el-col>
            <el-col :xs="4"
                    :sm="4"
                    :md="4"
                    :lg="4"
                    :xl="4">
              <p
                class="filter-close"
                @click="close()"
              >
                FECHAR
              </p>
            </el-col>
          </el-row>
        </div>
      </template>

<!--      Component Container vv-->
      <div class="filter-components-container">
        <FilterComponent
          v-for="(component, index) in componentList"
          :key="index"
          :component-data="component"
          :selected="outputMutable[component.field || component.title]"
          @update:selected="val => updateOutput(component, val)"
        />
      </div>
<!--      Component Container ^^-->

      <template v-slot:footer>
        <div class="filter-footer-box">
          <el-row justify="space-around" :gutter="10">
            <el-col
              :xs="12"
              :sm="12"
              :md="12"
              :lg="12"
              :xl="12"
              style=""
            >
              <el-button
                @click="clear(); close()"
                style="width: 100%;"
              >
                LIMPAR FILTROS
              </el-button>
            </el-col>
            <el-col
              :xs="12"
              :sm="12"
              :md="12"
              :lg="12"
              :xl="12"
              style=""
            >
              <el-button
                type="primary"
                @click="close(true)"
                style="width: 100%;"
              >
                APLICAR FILTROS
              </el-button>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import FilterComponent from '@/components/filterDialog/components/FilterComponent'

export default {
  name: 'filterDialog',
  components: { FilterComponent },
  props: {
    title: {
      type: String,
      default: 'Filtros'
    },
    open: {
      type: Boolean,
      default: false
    },
    componentList: {
      type: Array,
      default: () => []
    },
    output: {
      type: Object,
      default: () => { return {} }
    }
  },
  watch: {
    open (val) {
      this.localOpen = val
    },
    localOpen (val) {
      this.$emit('update:open', val)
    },
    output (newValue) {
      this.outputMutable = { ...newValue }
    }
  },
  data () {
    return {
      localOpen: this.open,
      outputMutable: {}
    }
  },
  created () {
    this.outputMutable = { ...this.output }
  },
  methods: {
    updateOutput (component, value) {
      const key = component.field || component.title
      this.$set(this.outputMutable, key, value)
    },
    close (aplica) {
      if (aplica) {
        this.$emit('update:output', { ...this.outputMutable })
      }

      this.$emit('update:open', false)
    },
    clear () {
      this.$emit('update:output', {})
    },
    handleClose () {
      this.localOpen = false
    }
  }
}
</script>
<style>
.filter-dialog {
  background: #FFFFFF 0 0 no-repeat padding-box;
  border-radius: 8px;
  /*margin-top: 5vh !important;*/
  max-height: 120vh;
  margin-top:100px !important;
}
</style>

<style scoped>
.el-dialog__body {
  overflow: auto;
  padding: 0 20px !important;
}
.filter-title-box {
  border-bottom: 1px solid #CCCCCC;
}

.filter-title {
  font: normal normal 600 24px/29px Open Sans;
  font-weight: 600;
  letter-spacing: 0;
  color: #333333;
}

.filter-close {
  font: normal normal 600 13px/16px Open Sans;
  font-weight: 600;
  letter-spacing: 0;
  color: #1074FF;
  cursor: pointer;
}

.filter-footer-box {
  padding: 10px;
  border-top: 1px solid #CCCCCC;
}

.filter-components-container {
  overflow: auto;
  max-height: 50vh;
  /*max-height: 70vh;*/
}
</style>
